import { LOCAL_ORG_USER, LOCAL_USER_ROLE } from '../../../../../constants';
import { addTimezoneLocal, tryParseJSON } from '../../../../../utils';

import { SET_SUBSCRIBER_USER, UPDATE_SUBSCRIBER_USER } from './actions';
import { SET_SUBSCRIBER_USER_TIME_ZONE } from './actions';

const INITIAL_STATE = null;

const userReducer = (state = INITIAL_STATE, action) => {
     switch (action.type) {
          case SET_SUBSCRIBER_USER: {
               if (action.payload) {
                    localStorage.setItem(LOCAL_USER_ROLE, action.payload.role);

                    // Add timezone to localStore
                    const orgUserLocal = tryParseJSON(localStorage.getItem(LOCAL_ORG_USER));

                    if (!!orgUserLocal?.organization) {
                         addTimezoneLocal(orgUserLocal.organization.timezone);
                    } else {
                         addTimezoneLocal(action.payload.timezone);
                    }
               }
               return action.payload;
          }
          case SET_SUBSCRIBER_USER_TIME_ZONE: {
               return {
                    ...state,
                    timezone: action.payload,
               };
          }
          case UPDATE_SUBSCRIBER_USER: {
               return {
                    ...state,
                    ...action.payload,
               };
          }
          default:
               return state;
     }
};

export default userReducer;
